import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Form, Input } from 'rsuite';
import { Unvisible, Visible } from '@rsuite/icons';

const Caixa = styled.div`
  position: relative;
  width: 100%;

  .rs-input {
    width: 100% !important;
    padding-right: 40px !important;
  }

  button {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #575757;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const InputSenha = React.forwardRef(({ value, onChange, name }, ref) => {
  const [visivel, setVisivel] = useState(false);

  function alternarVisibilidade() {
    setVisivel(!visivel);
  }

  return (
    <Caixa>
      <Input
        inputRef={ref}
        name={name}
        type={visivel ? 'text' : 'password'}
        value={value == null ? '' : value}
        onChange={(valor) => onChange(valor)}
        autoComplete="off"
      />
      <button type="button" onClick={() => alternarVisibilidade()} tabIndex={-1}>
        {visivel ? <Unvisible /> : <Visible />}
      </button>
    </Caixa>
  );
});

InputSenha.displayName = 'InputSenha';

InputSenha.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
};

InputSenha.defaultProps = {
  value: '',
  onChange: undefined,
  name: undefined,
};

export default function CampoSenha({ label, value, onChange, name }) {
  return (
    <Form.Group>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <InputSenha name={name} value={value} onChange={(valor) => onChange(valor)} />
    </Form.Group>
  );
}

CampoSenha.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};
